import { render, staticRenderFns } from "./penilaian.vue?vue&type=template&id=3e109702&"
import script from "./penilaian.vue?vue&type=script&lang=js&"
export * from "./penilaian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports